/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type MagnifyingGlassIconIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function MagnifyingGlassIconIcon(props: MagnifyingGlassIconIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
      viewBox={"0 0 64 64"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M58.828 53.172L43.407 37.75a21.115 21.115 0 01-5.657 5.657l15.422 15.421a4 4 0 005.656-5.656zM9.918 37.839A19.962 19.962 0 0137.84 9.918l1.442-1.442A21.986 21.986 0 008.476 39.281l1.442-1.442z"
        }
        fill={"#99CAFD"}
      ></path>

      <path
        d={
          "M42.082 14.16A19.962 19.962 0 0114.16 42.082l-1.442 1.441a21.986 21.986 0 0030.806-30.805l-1.442 1.442zM5 48a1 1 0 01-.707-1.707l42-42a1 1 0 111.414 1.414l-42 42A1 1 0 015 48z"
        }
        fill={"#99CAFD"}
      ></path>
    </svg>
  );
}

export default MagnifyingGlassIconIcon;
/* prettier-ignore-end */
